import styled from "styled-components";
import animate from "../../../utils/animations";

export const Wrapper = styled.div`
  z-index: 1;
  background-color: #fff;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 0;
  top: 0;
`;

export const Icon = styled.div`
  margin: 10px 0;
  font-size: 2em;
  ${animate("fadeInUp", 0.3, 0.1)};
`;

export const Text = styled.div`
  text-align: center;
  font-size: 1.2em;
  font-weight: 400;
  margin: 10px 0 20px 0;
  ${animate("fadeInUp", 0.3, 0.2)};
`;

export const Button = styled.button`
  font-weight: bold;
  color: #fff;
  background: #f2008c;
  border: 1px solid #f2008c;
  box-sizing: border-box;
  border-radius: 4px;
  line-height: 22px;
  text-rendering: optimizeLegibility;
  padding: 10px 12px;
  font-family: Raleway;
  text-align: center;
  letter-spacing: 0.03em;
  text-transform: capitalize;
  font-size: 1em;
  min-width: 100px;
  transition: 0.15s ease-in-out;
  ${animate("fadeInUp", 0.3, 0.3)};

  &:hover {
    cursor: pointer;
    color: #fff;
    background: #bc006d;
    border: 1px solid #f2008c;
  }
`;
